export default __webpack_public_path__ + "images/ad2319fd41798b660bd248a4bdb76034.svg";